
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/pronunciation",
      function () {
        return require("private-next-pages/courses/pronunciation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/pronunciation"])
      });
    }
  